// extracted by mini-css-extract-plugin
module.exports = {"widget":"TotalResultsCount_widget__BxWur"};